module.exports = __webpack_public_path__ + "static/media/login-logo.76094c17.svg";